export const VeryDarkDesaturatedBlue = "hsl(212, 27%, 19%)";
export const VeryDarkGrayishBlue = "hsl(213, 9%, 39%)";
export const DarkGrayishBlue = "hsl(232, 10%, 55%)";
export const GrayishBlue = "hsl(210, 4%, 67%)";
export const White = "hsl(0, 0%, 100%)";

export const Fraunces = "Fraunces";
export const Barlow = "Barlow";